<template>
  <div>
    <h5-header v-if="!isUle" :class="!isUle?'h5headStyle':''" :isUcbank="isUcbank"></h5-header>
    <activityPage-one v-if="activityTimes==0" :isUcbank="isUcbank"></activityPage-one>
    <activityPage-two v-if="activityTimes==1" :isUcbank="isUcbank"></activityPage-two>
    <yinbao-pag v-if="activityTimes==2" :isUcbank="isUcbank"></yinbao-pag>
    <fanchang-pag v-if="activityTimes==3" :isUcbank="isUcbank"></fanchang-pag>
    <!-- <slider-menu :type="1"></slider-menu> -->
  </div>
</template>

<script>
import Vue from "vue";
import { Toast } from "mint-ui";
import * as URL from "../../assets/js/url.js";
import activityPageOne from "../pages/preheat"; //预热活动页面
import activityPageTwo from "../pages/main"; //正式活动页面
import yinbaoPag from "../pages/yinbao"; //引爆期
import fanchangPag from "../pages/fanchang"; //返场期
import h5Header from "../common/head";
import sliderMenu from "../../components/common/sliderMenu";
export default {
  data() {
    return {
      sysTime: "",
      // preheatTime: "2019/08/26 00:00:00", //预热期开始时间
      activityTime: "2019/08/30 00:00:00", //活动期开始时间
      activityTimeTwo: "2019/09/19 00:00:00", //引爆期开始时间
      activityTimeThree: "2019/09/20 00:00:00", //返场期开始时间
      activityTimes: null,
      urlTime: "", //地址栏传值的当前时间
      isUle: false, //是否app客户端环境
      isUcbank: false //是否邮储银行app
    };
  },
  created() {
    this.isUle = this.BASE.$browser().ule;
    if (this.BASE.getUrlStr("time")) {
      this.urlTime = new Date(
        decodeURIComponent(this.BASE.getUrlStr("time")).replace(/-/g, "/")
      );
      console.log(
        decodeURIComponent(this.BASE.getUrlStr("time")).replace(/-/g, "/")
      );
    }
    this.datetime(); //获取系统时间
    this.initYctitle();
  },
  methods: {
    initYctitle() {
      //判断是否为邮储银行入口
      let urlType = this.BASE.getUrlStr("client_type"),
        cookieType = this.BASE.getCookie("client_type");
      if (urlType == "app_psbc" || cookieType == "app_psbc") {
        //邮储银行环境，将邮储标识存入cookie
        if (cookieType != "app_psbc" || !cookieType) {
          this.BASE.setCookie("client_type", "app_psbc");
        }
        this.isUcbank = true;
      }
    },
    datetime() {
      this.HTTP.datetime()
        .then(res => {
          this.sysTime = new Date(res.time);
          this.chooseComponent();
        })
        .catch(err => {
          this.sysTime = new Date();
          this.chooseComponent();
        });
    },
    chooseComponent() {
      // let time = this.urlTime;

      console.log("当前时间：" + time);
      //地址栏有时间参数使用时间判断逻辑展示相应活动，无时间参数手动控制展示活动
      // if (time) {
      //   if (time < new Date(this.activityTime)) {
      //     //预热器
      //     this.activityTimes = 0;
      //   } else if (time < new Date(this.activityTimeTwo)) {
      //     //活动期
      //     this.activityTimes = 1;
      //   } else if (time < new Date(this.activityTimeThree)) {
      //     //引爆期
      //     this.activityTimes = 2;
      //   } else {
      //     //返场期
      //     this.activityTimes = 3;
      //   }
      // } else {
      //   //手动控制显示活动
      //   this.activityTimes = 1;
      // }
      let time = this.urlTime ? this.urlTime : this.sysTime;
      if (time < new Date(this.activityTime)) {
        //预热器
        this.activityTimes = 0;
      } else if (time < new Date(this.activityTimeTwo)) {
        //活动期
        this.activityTimes = 1;
      } else if (time < new Date(this.activityTimeThree)) {
        //引爆期
        this.activityTimes = 2;
      } else {
        //返场期
        this.activityTimes = 3;
      }
    }
  },
  components: {
    activityPageOne,
    activityPageTwo,
    yinbaoPag,
    fanchangPag,
    h5Header,
    sliderMenu
  }
};
</script>

<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue